import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from '@fiverr-private/fit';
import { d_search } from '@fiverr-private/fit/icons';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import LazyPersonalizedSectionFetcher from '../../../../../../../shared/components/LazyPersonalizedSectionFetcher';
import { PAGE_NAME } from '../../../../../shared/constants';
import { setAllCollections } from '../../../../../store/collections/actions';

import classes from './style.module.scss';

const EmptyViewDefault = ({ collections, setAllCollections }) => {
    const { userId } = getContext();
    const isLoggedIn = !!userId;

    return (
        <div>
            <div className={classes.title}>
                <Icon size={46}>{d_search}</Icon>
                <p className={classes.mainTitle}>
                    <I18n k="collections_perseus.collection_page.keep_everything" />
                </p>
                <p>
                    <I18n k="collections_perseus.collection_page.some_ideas" />
                </p>
            </div>
            {isLoggedIn && (
                <LazyPersonalizedSectionFetcher
                    className="empty-recommendations"
                    sectionName="cold_start_carousels"
                    collections={collections}
                    onUpdateCollections={setAllCollections}
                    pageName={PAGE_NAME}
                />
            )}
        </div>
    );
};

EmptyViewDefault.propTypes = {
    collections: PropTypes.arrayOf(PropTypes.object),
    setAllCollections: PropTypes.func,
};

const mapDispatchToProps = { setAllCollections };

const mapStateToProps = ({ collections }) => ({ collections });

export { EmptyViewDefault };
export default connect(mapStateToProps, mapDispatchToProps)(EmptyViewDefault);
